import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import Overview from './Overview';
import Publishers from './Publishers';
import Contribution from './Contribution';
import Credit from './Credit';
import LicensingPermissions from './LicensingPermissions';
import GoverningLaw from './GoverningLaw';
import NameLikeness from './NameLikeness';
import Indemnification from './Indemnification';
import DisputeResolution from './DisputeResolution';
import CureRemedies from './CureRemedies';
import Consideration from './Consideration';

import Services from './Services';
import Ownership from './Ownership';
import Payments from './Payments';
import CreditNameLikeness from './CreditNameLikeness';

import { getMemberNameByUserId } from '../../utils';

import checkMatchingStatus from '../Deals/DealEditPages/helpers/checkMatchingStatus';
import getDealChangeRequests from '../Deals/DealEditPages/helpers/getDealChangeRequests';
import Accepts from '../Deals/DealEditPages/Accepts';

class DealContractBlock extends Component {
  getBlockDealChangeRequests() {
    const { block, dealChanges, agreement, dealUsers, members, deal } =
      this.props;

    let {
      changeRequests,
      allChangeRequests,
      accepts,
      changeRequests2,
      accepts2,
    } = getDealChangeRequests(
      block,
      dealChanges,
      members,
      deal,
      agreement,
      dealUsers
    );

    // Make the changes to be accepted if it matched to owner's changes
    const currentBlockChange = _.find(
      this.props.agreementContractBlocks,
      (contract) => contract.contract_block === block.id
    );

    if (changeRequests.length > 0 && currentBlockChange) {
      let filteredReqest = [];
      if (block.name === 'Licensing Permissions') {
        filteredReqest = _.filter(changeRequests, (change) =>
          _.isEqual(
            currentBlockChange
              ? _.sortBy(JSON.parse(currentBlockChange.options).licenserIds)
              : [],
            _.sortBy(change.changes.licenserIds)
          )
        );
        changeRequests = _.filter(
          changeRequests,
          (change) =>
            !_.isEqual(
              currentBlockChange
                ? _.sortBy(JSON.parse(currentBlockChange.options).licenserIds)
                : [],
              _.sortBy(change.changes.licenserIds)
            )
        );
      } else {
        filteredReqest = _.filter(changeRequests, (change) =>
          checkMatchingStatus(
            change.changes,
            JSON.parse(currentBlockChange.options),
            true
          )
        );
        changeRequests = _.filter(changeRequests, (change) =>
          checkMatchingStatus(
            change.changes,
            JSON.parse(currentBlockChange.options),
            false
          )
        );
      }

      if (filteredReqest.length > 0) {
        filteredReqest.forEach((request) => {
          request.users.forEach((user) => {
            accepts.push({ user });
          });
        });
      }
    }

    if (changeRequests2.length > 0 && currentBlockChange) {
      const filteredReqest = _.filter(changeRequests2, (change) =>
        checkMatchingStatus(
          change.changes,
          JSON.parse(currentBlockChange.options),
          true
        )
      );
      changeRequests2 = _.filter(changeRequests2, (change) =>
        checkMatchingStatus(
          change.changes,
          JSON.parse(currentBlockChange.options),
          false
        )
      );

      if (filteredReqest.length > 0) {
        filteredReqest.forEach((request) => {
          request.users.forEach((user) => {
            accepts2.push({ user });
          });
        });
      }
    }

    return {
      changeRequests,
      allChangeRequests,
      renderAccepts: () => <Accepts accepts={accepts} />,
      changeRequests2,
      renderAccepts2: () => <Accepts accepts={accepts2} />,
    };
  }

  render() {
    const { deal, profile, members, contractBlocks } = this.props;
    let userInfo = {
      same: false,
      name: '',
    };

    if (deal && profile) {
      if (deal.user === profile.id) {
        userInfo.same = true;
      } else if (members) {
        userInfo.same = false;
        userInfo.name = getMemberNameByUserId(deal.user, members);
      }

      switch (this.props.block.name) {
        case 'Overview':
          return (
            <Overview
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Publishers':
          return (
            <Publishers
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Contribution':
          return (
            <Contribution
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Credit':
          return (
            <Credit
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Licensing Permissions':
          return (
            <LicensingPermissions
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Governing Law':
          return (
            <GoverningLaw
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Name & Likeness':
          return (
            <NameLikeness
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Indemnification':
          return (
            <Indemnification
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Dispute Resolution':
          return (
            <DisputeResolution
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Cure; Remedies':
          return (
            <CureRemedies
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Consideration':
          return (
            <Consideration
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );

        case 'Services':
          return (
            <Services
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Ownership':
          return (
            <Ownership
              {...this.props}
              userInfo={userInfo}
              contractBlocks={contractBlocks}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Payments':
          return (
            <Payments
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        case 'Credit; Name and Likeness':
          return (
            <CreditNameLikeness
              {...this.props}
              userInfo={userInfo}
              {...this.getBlockDealChangeRequests()}
            />
          );
        default:
          return null;
      }
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  roles: state.global.roles,
  ownershipTypes: state.global.ownershipTypes,
  contractBlocks: state.global.contractBlocks,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypes,
  agreementContractBlocks: state.agreements.contractBlocks,
  agreement: state.agreements.selectedAgreement,
  members: state.users.members,
  deal: state.deals.selectedDeal,
  dealBlocks: state.dealBlocks.dealBlocks,
  dealChanges: state.deals.dealChanges,
  dealUsers: state.dealUsers.dealUsers,
  invites: state.invites.invites,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  removeBlockChanges: (id) => {
    dispatch(actions.removeDealBlockChanges(id));
  },
  setBlockChanges: (changes) => {
    dispatch(actions.setDealBlockChanges(changes));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DealContractBlock);



// WEBPACK FOOTER //
// src/components/DealContractBlock/index.jsx